import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { VendorScorecardReport } from "@/features/office/reports/vendor-scorecard";
import { maskSearchFragment } from "@/features/shared/route-masking";

// Lenient URL schema (strict enums on URL params crash the page — see
// webapp-routing.md). `market` and `type` are the switches (absent = all),
// `trade` the picked trade row, `vendor` the picked bubble, `sort` the
// table's order (absent = revenue).
const searchSchema = z.object({
  market: z.string().optional().catch(undefined),
  type: z.string().optional().catch(undefined),
  trade: z.string().optional().catch(undefined),
  vendor: z.string().optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  ...maskSearchFragment,
});

export const routeId = "/office/reports/vendor-scorecard";
export const Route = createFileRoute("/office/reports/vendor-scorecard")({
  validateSearch: searchSchema,
  component: VendorScorecardReport,
});
